import React from 'react';
import { useTranslation } from 'react-i18next';
import XtramModal, { XtramButton, XtramNotice, xtramStyles } from '../Widgets/XtramModal/XtramModal';
import styles from './BankXtram.module.scss';

/** Confirmation before removing a bank/card match; `showTransactionDate` adds the transaction date row. */
const RemoveMatchConfirmModal = ({
    open,
    onClose,
    onConfirm,
    match,
    formatDate,
    direction,
    busy = false,
    showTransactionDate = true,
}) => {
    const { t } = useTranslation();
    if (!match) return null;

    const formatOptionalDate = (value) => (value ? formatDate(value) : '-');
    const details = [
        { label: t('CaseID'), value: match.caseId },
        { label: t('AccountCard Name'), value: match.accountCardName },
        { label: t('AccountCodeID'), value: match.accountCodeId },
        ...(showTransactionDate ? [{ label: t('TransactionDate'), value: formatOptionalDate(match.transactionDate) }] : []),
        { label: t('MatchDate'), value: formatOptionalDate(match.matchDate) },
        { label: t('MatchNumber'), value: match.matchNumber },
    ];

    return (
        <XtramModal
            open={open}
            onClose={onClose}
            title={t('ConfirmRemoval')}
            direction={direction}
            busy={busy}
            footer={
                <>
                    <XtramButton variant="secondary" onClick={onClose} disabled={busy}>{t('Cancel')}</XtramButton>
                    <XtramButton variant="danger" onClick={onConfirm} disabled={busy} busy={busy}>{t('Confirm')}</XtramButton>
                </>
            }
        >
            <div className={xtramStyles.section}>
                <XtramNotice type="warning">{t('ConfirmRemoveMatch')}</XtramNotice>
                <div className={xtramStyles.card}>
                    <div className={styles.kvList}>
                        {details.map((item) => (
                            <div key={item.label} className={styles.kv}>
                                <span className={styles.kvLabel}>{item.label}</span>
                                <span className={styles.kvValue}>{item.value ?? '-'}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </XtramModal>
    );
};

export default RemoveMatchConfirmModal;
